export default {
  RentalPackageDesc: "RentalPackageDesc",
  AddRentalPackageDesc: "AddRentalPackageDesc",
  editRentalPackageDesc: "EditRentalPackageDesc",
};
